module.exports = __webpack_public_path__ + "static/assets/c0b901adf2fec27d76f4373824ed2cfa.png";